const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const ListTable = require('app/ui/list/Table');
const GraphQLMutation = require('app/graphql/Mutation');

class CreditAgricoleTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.buildFooter = this.buildFooter.bind(this);
        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);
        this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.invoiceWithoutSepas = [];
        this.invoiceWithoutBillingPeriods = [];
        this.selection = [];

        this.initialize();
    }

    initialize() {
        var self = this;

        this.buildTab();
    }

    onDOMReady(){

    }

    buildTab(){


        this.$tableContainer = $('<div/>')
        .addClass('white-box');

        this.$container
        .html('')
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-9 p-2')
                .append(this.$tableContainer)
            )
            .append(
                $('<div/>')
                .addClass('col-3 p-2')
                .append(
                    $('<div/>')
                    .addClass('white-box')
                    .append( this.buildActionContainer())
                )
            )
        );

        this.initializeListTable();

        this.onDOMReady();
    }

    buildActionContainer(){
        var self = this;
        this.$actionContainer = $('<div/>');


        this.$toggleShowInvalid = $('<input/>')
        .attr('type','checkbox')
        .attr('id','toggleInvalid')
        .addClass('form-check-input')
        .val(1)
        .on('change',function(){
            self.toggleInvalid();
        });


        this.$selectionActionContainer = $('<div/>');

        this.$actionContainer
        .append(
            $('<div/>')
            .addClass('form-check')
            .append(this.$toggleShowInvalid)
            .append(
                $('<label/>')
                .attr('for','toggleInvalid')
                .append(window.translate('app.billing.payment.list.tabs.credit_agricole.actions.toggleInvalid.label'))
            )
        )
        .append(this.$selectionActionContainer)

        return this.$actionContainer;
    }

    drawSelectionAction(){
        var self = this;
        this.$selectionActionContainer
        .html('');


        if(this.selection.length > 0){
            let now = moment().format('YYYY-MM-DD');
            this.$inputDate = $('<input/>')
            .attr('type','date')
            .addClass('form-control')
            .val(now)
            .on('change',function(){
                $('.btn-download',this.$selectionActionContainer).remove();
            })

            let $list = $('<ul/>')
            .addClass('list-unstyled');
            let btns = [];

            let $btnDownloadBankFile = $('<button/>')
            .attr('type','button')
            .addClass('btn btn-success')
            .append(
                $('<i/>')
                .addClass('fas fa-file-code me-1')
            )
            .append(window.translate('app.billing.payment.list.tabs.credit_agricole.actions.downloadBankFile.generate'))
            .on('click',function(){
                self.onClickGenerateDownloadBankFile($btnDownloadBankFile)
            });
            btns.push($btnDownloadBankFile);

            let $btnDownloadList = $('<button/>')
            .attr('type','button')
            .addClass('btn btn-warning')
            .append(
                $('<i/>')
                .addClass('fas fa-file-pdf me-1')
            )
            .append(window.translate('app.billing.payment.list.tabs.credit_agricole.actions.downloadList.generate'))
            .on('click',function(){
                self.onClickGenerateDownloadList($btnDownloadList)
            });
            btns.push($btnDownloadList);


            let $btnValidate = $('<button/>')
            .attr('type','button')
            .addClass('btn btn-danger')
            .append(
                $('<i/>')
                .addClass('fas fa-check me-1')
            )
            .append(window.translate('app.billing.payment.list.tabs.credit_agricole.actions.validate.label'))
            .on('click',function(){
                self.onClickValidate($btnValidate);
            })
            btns.push($btnValidate);

            for(var i in btns){
                let $btn = btns[i];
                $list.append(
                    $('<li/>')
                    .addClass('p-1')
                    .append($btn)
                )
            }

            this.$selectionActionContainer
            .append('<hr/>')
            .append(
                $('<div/>')
                .addClass('form-group')
                .append(
                    $('<label/>')
                    .attr('for',"date")
                    .append(window.translate('app.billing.payment.list.tabs.credit_agricole.actions.date.label'))
                )
                .append(this.$inputDate)
            )
            .append($list);

            this.$selectionActionContainer.show();
        }else{

            this.$selectionActionContainer
            .hide();
        }
    }

    toggleInvalid(){
        if(this.$toggleShowInvalid.is(':checked')){
            $('.invoice-sepa-missing').show();
        }else{
            $('.invoice-sepa-missing').hide();
        }
    }

    onSubmitFilterForm(event){
        event.preventDefault()
        event.stopPropagation();

        this.table.refresh();
    }

    refresh(){
        this.table.refresh();
    }

    getRestaurantForInvoice(invoice){
        if(invoice.customer){
            if(invoice.customer.restaurantAssociations.length > 0){
                let restaurantAssociation = invoice.customer.restaurantAssociations[0];
                return restaurantAssociation.restaurant;
            }
        }
        return null;
    }

    isInvoiceWithBillingPeriod(invoice){
        if(invoice.billingPeriod){
            return true;
        }
        return false;
    }

    isInvoiceWithSepa(invoice){
        let restaurant = this.getRestaurantForInvoice(invoice);
        if(restaurant){
            if(restaurant.sepas && restaurant.sepas.length > 0){
                return true;
            }
        }
        return false;
    }

    onChangeCheckAll(){

        $('.invoice-checkbox',this.$tableContainer)
        .prop('checked',this.$checkAll.is(':checked'));

        this.onChangeSelection();
    }

    onChangeSelection(){
        var self = this;
        let $selection = $('.invoice-checkbox:checked',this.$tableContainer);
        this.selection = [];
        $selection.each(function(){
            let $checkbox = $(this);
            self.selection.push(parseInt($checkbox.val()));
        });

        this.drawSelectionAction();
    }

    initializeListTable(){
        var self = this;

        let fields = [
            'id',
            'reference',
            'date',
            'customerName',
            'customer { name restaurantAssociations { restaurant { name sepas { iban } } } }',
            'totalAlreadyPayed',
            'remainingDue',
            'billingPeriod { begin end levy }'
        ];

        this.$checkAll = $('<input/>')
        .attr('type','checkbox')
        .val('all')
        .on('click',function(){
            self.onChangeCheckAll();
        })

        this.table = new ListTable({
            '$container': this.$tableContainer,
            'tableClass': 'table table-striped billing-invoice-list',
            'footerBuilder': {
                'mode': 'custom',
                'render': this.buildFooter,
            },
            'showPagination': false,
            'id': 'list-billing-invoices',
            'length': 0,//leave 0 to show all and retrieve all 
            'graphQL': {
                'queryType': 'billingInvoices',
                'fields': fields,
                'parameters': this.buildGraphQLParameters,

            },
            'onLoadComplete': function(){
                self.invoiceWithoutSepas = [];
                self.invoiceWithoutBillingPeriods = [];
            },
            'onDrawn': function(){
                self.toggleInvalid();
            },
            'onDrawLine': function($row,item,index){
                let hasError = false;
                if(!self.isInvoiceWithSepa(item.node)){
                    self.invoiceWithoutSepas.push(item.node);
                    hasError = true;
                    $row.addClass('invoice-sepa-missing');
                }else if(!self.isInvoiceWithBillingPeriod(item.node)){
                    self.invoiceWithoutBillingPeriods.push(item.node);
                    $row.addClass('invoice-billingperiod-missing');
                }
                if(hasError){
                    $row
                    .addClass('table-danger');
                }
            },
            'columns': [
                {
                    'name': 'select',
                    'label': this.$checkAll,
                    'class': 'billing-invoice-select',
                    'render': function(item,index){
                        let $content = $('<div/>');

                        let sepaMissing = self.isInvoiceWithSepa(item.node) ? false : true;
                        let billingPeriodMissing = self.isInvoiceWithBillingPeriod(item.node) ? false : true;
                        if(sepaMissing){
                            let $icon = $('<i/>')
                            .addClass('fas fa-credit-card text-danger')
                            .attr('title',window.translate('app.billing.payment.list.tabs.credit_agricole.sepaMissing.single'))
                            $content.append($icon);
                        } else {
                            let $checkThis = $('<input/>')
                            .attr('type','checkbox')
                            .attr('data-item',item.node)
                            .addClass('invoice-checkbox')
                            .val(item.node.id)
                            .on('click',function(){
                                self.onChangeSelection();
                            });
                            $content.append($checkThis);
                        }


                        if(billingPeriodMissing){
                            let $icon = $('<i/>')
                            .addClass('fas fa-calendar-times text-danger ms-2')
                            .attr('title',window.translate('app.billing.payment.list.tabs.credit_agricole.billingPeriodMissing.single'))
                            $content.append($icon);
                        }

                        return $content;
                    },
                },
                {
                    'name': 'date',
                    'label': window.translate('billing.invoice.date.label'),
                    'class': 'billing-invoice-date',
                    'render': function(item,index){
                        return window.formatDate(item.node.date,window.translate('momentDateFormat.fullDay'));
                    },
                },
                {
                    'name': 'reference',
                    'label': window.translate('billing.payment.invoice.label'),
                    'class': 'billing-invoice-reference',
                    'render': function(item,index){
                        return item.node.reference;
                    },
                },
                {
                    'name': 'customer',
                    'label': window.translate('billing.invoice.customer.label'),
                    'class': 'billing-invoice-customer',
                    'render': function(item,index){
                        return item.node.customer ? item.node.customer.name : item.node.customerName;
                    },
                },
                {
                    'name': 'totalAlreadyPayed',
                    'label': window.translate('app.billing.payment.list.tabs.credit_agricole.list.amount.label'),
                    'class': 'billing-invoice-totalAlreadyPayed',
                    'render': function(item,index){
                        return window.formatFloat(item.node.remainingDue) + ' &euro;';
                    },
                },
            ]
        })
    }

    buildFooter(data){
        let rows = [];

        let $row = $('<tr/>');
        if(data.length <= 1){
            return '';
        }

        let totalRemainingDue = 0;

        for(var i in data){
            let item = data[i].node;
            totalRemainingDue += parseFloat(item.remainingDue);
        }

        $row
        .append(
            $('<td/>')
            .append("&nbsp;")
        )
        .append(
            $('<td/>')
            .append("&nbsp;")
        )
        .append(
            $('<td/>')
            .append("&nbsp;")
        )
        .append(
            $('<td/>')
            .append(window.translate('app.billing.payment.list.tabs.credit_agricole.list.total.label'))
        )
        .append(
            $('<td/>')
            .append(window.formatFloat(totalRemainingDue) + ' &euro;')
        )
        rows.push($row);

        if(this.invoiceWithoutSepas.length > 0){
            let restaurantNames = this.getRestaurantNamesInInvoices(this.invoiceWithoutSepas);
            let $sepaRow = $('<tr/>')
            .append(
                $('<td/>')
                .attr('colspan',5)
                .append(
                    $('<div/>')
                    .addClass('alert alert-danger fw-bold text-center')
                    .append(
                        $('<i/>')
                        .addClass('fas fa-2x fa-exclamation-triangle text-danger float-end')
                    )
                    .append(window.translate('app.billing.payment.list.tabs.credit_agricole.sepaMissing.general'))
                    .append('<br/>')
                    .append(restaurantNames.join(', '))
                )
            )
            rows.push($sepaRow);
        }
        if(this.invoiceWithoutBillingPeriods.length > 0){
            let restaurantNames = this.getRestaurantNamesInInvoices(this.invoiceWithoutBillingPeriods);
            let $billingPeriodRow = $('<tr/>')
            .append(
                $('<td/>')
                .attr('colspan',5)
                .append(
                    $('<div/>')
                    .addClass('alert alert-danger fw-bold text-center')
                    .append(
                        $('<i/>')
                        .addClass('fas fa-2x fa-exclamation-triangle text-danger float-end')
                    )
                    .append(window.translate('app.billing.payment.list.tabs.credit_agricole.billingPeriodMissing.general'))
                    .append('<br/>')
                    .append(restaurantNames.join(', '))
                )
            )
            rows.push($billingPeriodRow);
        }
        return rows;
    }

    getRestaurantNamesInInvoices(invoices){
        let names = [];
        for(var i in invoices){
            let invoice = invoices[i];
            let name = invoice.customer ? invoice.customer.name : invoice.customerName;
            if(!names.includes(name)){
                names.push(name);
            }
        }
        return names.sort();
    }

    buildGraphQLParameters(){
        let filters = {
            'customerType': 'Restaurant',
            'fullyPayed': false,
            'hasDue': true,
        };

        let orderBy = 'date';
        let dir = "ASC";

        let parameters = {
            'filter' : filters,

            'orderBy': orderBy,
            'dir': dir,
        };


        return parameters;
    }

    onClickGenerateDownloadBankFile($btn){
        var self = this;

        let oldHtml = $btn.html();

        let $spinner = window.App.generateLoader();

        $btn
        .html('')
        .append($spinner);

        let fields = [
            'success',
            'message',
            'file { url id }',
            'errors { key, value }',
        ];
        let variables = {
            'type':{
                'value': 'xml',
                'type': "String!"
            },
            'date':{
                'value': this.$inputDate.val(),
                'type': "Date!"
            },
            'invoices': {
                'value': this.selection,
                'type': "[Int]"
            }
        };

        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "ExportBillingPaymentForBank",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    let url = window.App.get('apiBaseUrl')+data.file.url;
                    let $btnDownload = $('<a/>')
                    .attr('download','download')
                    .attr('target','_blank')
                    .attr('href',url)
                    .addClass('btn btn-text text-primary')
                    .addClass('btn-download')
                    .attr('title',window.translate('download'))
                    .append(
                        $('<i/>')
                        .addClass("fas fa-download")
                    )
                    $btn.after($btnDownload);
                }else{
                    window.notify(data.message,'error');
                }
            },
            'error': function(message, xhr){
                window.notify(message,'error');
            },
            'after': function(){
                $btn.html('').append(oldHtml)
            }
        });
        mutation.execute();
    }

    onClickGenerateDownloadList($btn){
        var self = this;

        let oldHtml = $btn.html();

        let $spinner = window.App.generateLoader();

        $btn
        .html('')
        .append($spinner);

        let fields = [
            'success',
            'message',
            'file { url id }',
            'errors { key, value }',
        ];
        let variables = {
            'type':{
                'value': 'pdf',
                'type': "String!"
            },
            'date':{
                'value': this.$inputDate.val(),
                'type': "Date!"
            },
            'invoices': {
                'value': this.selection,
                'type': "[Int]"
            }
        };

        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "ExportBillingPaymentForBank",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    let url = window.App.get('apiBaseUrl')+data.file.url;
                    let $btnDownload = $('<a/>')
                    .attr('download','download')
                    .attr('target','_blank')
                    .attr('href',url)
                    .addClass('btn btn-text text-primary')
                    .addClass('btn-download')
                    .attr('title',window.translate('download'))
                    .append(
                        $('<i/>')
                        .addClass("fas fa-download")
                    )
                    $btn.after($btnDownload);
                }else{
                    window.notify(data.message,'error');
                }
            },
            'error': function(message, xhr){
                window.notify(message,'error');
            },
            'after': function(){
                $btn.html('').append(oldHtml)
            }
        });
        mutation.execute();
    }

    onClickValidate($btn){
        var self = this;

        let oldHtml = $btn.html();

        let $spinner = window.App.generateLoader();

        $btn
        .html('')
        .append($spinner);

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'date':{
                'value': this.$inputDate.val(),
                'type': "Date!"
            },
            'invoices': {
                'value': this.selection,
                'type': "[Int]"
            }
        };

        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "ConfirmBillingPaymentFromBank",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    self.refresh();
                    window.notify(data.message,'success');
                }else{
                    window.notify(data.message,'error');
                }
            },
            'error': function(message, xhr){
                window.notify(message,'error');
            },
            'after': function(){
                $btn.html('').append(oldHtml)
            }
        });
        mutation.execute();
    }
}

module.exports = CreditAgricoleTab;

